<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title py-2 px-2 pb-0 mb-0">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'">
          <label class="d-flex align-items-center mb-0">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div [ngClass.xl]="'float-left ml-2'" [ngClass.md]="'float-left ml-2'" [ngClass.sm]="'mt-1'">
          <select [(ngModel)]="selectedCategory" (ngModelChange)="ticketList()" class="form-control">
            <option selected disabled value="all">{{ "CATEGORY" | translate }}</option>
            <option value="all">{{ "ALL" | translate }}</option>
            <option *ngFor="let category of categories">{{ category.name }}</option>
          </select>
        </div>
        <div [ngClass.xl]="'float-left ml-2'" [ngClass.md]="'float-left ml-2'" [ngClass.sm]="'mt-1'">
          <select [(ngModel)]="searchStatus" class="form-control">
            <option value="10" selected>{{ "ALL" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "TAKEN_CHARGE" | translate }}</option>
            <option value="2">{{ "COMPLETED" | translate }}</option>
          </select>
        </div>
        <div class="float-right" [ngClass.sm]="'d-none'">
          <div class="d-inline-block">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 210"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [footerHeight]="50"
          [rows]="ticketList()">
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="id" width="150" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="text-break-line-2" [ngbTooltip]="row.title">{{ row.title }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TITLES.USERS_TYPES_SINGULAR.employee' | translate }}" prop="user.complete_name" width="150" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.user.complete_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'CATEGORY' | translate }}" prop="category_name" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.category_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'OPERATOR' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span *ngIf="!row.last_step.operator?.complete_name || row.last_step.operator?.complete_name.trim().length < 1">-</span>
              <a *ngIf="row.last_step.operator?.complete_name && row.last_step.operator?.complete_name.trim().length > 1" [routerLink]="'/dashboard/user/profile/' + row.last_step.operator.hash">{{
                row.last_step.operator?.complete_name
                }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DATE' | translate }}" prop="insert_date" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.insert_date) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="last_step.status" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge mt-0" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)" [ngClass]="{
                    'badge-secondary': row?.last_step?.status===0,
                    'badge-warning': row?.last_step?.status===1,
                    'badge-success': row?.last_step?.status===2
                    }">{{ row?.enabled_label | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary btn-sm mr-1" (click)="modalOpen(viewTicket, row)" *ngIf="me.hash !== row.user_hash">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="title" width="200" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex align-items-center justify-content-between" ngClass.md="pr-1">
                    <span>{{ row.title }}</span>
                    <span class="badge mb-1" [ngClass]="{
                    'badge-secondary': row?.last_step?.status===0,
                    'badge-warning': row?.last_step?.status===1,
                    'badge-success': row?.last_step?.status===2
                    }">{{ row?.enabled_label | translate }}</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between my-1" ngClass.md="pr-1">
                    <span>{{ row.user.complete_name }}</span>
                    <span>{{ _utilService.formatDate(row.insert_date) }}</span>
                  </div>
                  <div class="mb-1" [ngClass.md]="'pl-0'">
                    <span *ngIf="row.last_step.operator.complete_name == ' '">-</span>
                    <span class="font-weight-bold mr-075" *ngIf="row.last_step.operator.complete_name != ' '">{{ "OPERATOR" | translate }}:</span>
                    <a *ngIf="row.last_step.operator.complete_name != ' '" [routerLink]="'/dashboard/user/profile/' + row.last_step.operator.hash">{{ row.last_step.operator.complete_name }}</a>
                  </div>
                  <div class="d-flex justify-content-end" ngClass.md="pr-1">
                    <button class="btn btn-outline-secondary btn-sm" (click)="modalOpen(viewTicket, row)" *ngIf="me.hash !== row.user_hash">{{ "VIEW" | translate }}</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal Detail Ticket -->
<ng-template #viewTicket let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "DETAIL_SUPPORT_REQUEST" | translate }}</h3>
      <div class="row">
        <div class="col-6" *ngIf="currentTicket?.title">
          <small class="text-muted mb-0 pb-0">{{ "NAME" | translate }}:</small>
          <p>{{ currentTicket?.title }}</p>
        </div>
        <div class="col-6" *ngIf="currentTicket?.user?.complete_name">
          <small class="text-muted mb-0 pb-0">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}:</small>
          <p>{{ currentTicket?.user?.complete_name }}</p>
        </div>
        <div class="col-4" *ngIf="currentTicket?.category_name">
          <small class="text-muted mb-0 pb-0">{{ "CATEGORY" | translate }}:</small>
          <p>{{ currentTicket?.category_name }}</p>
        </div>
        <div class="col-4" *ngIf="currentTicket?.insert_date">
          <small class="text-muted mb-0 pb-0">{{ "INSERT_DATE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentTicket?.insert_date) }}</p>
        </div>
        <div class="col-4" *ngIf="currentTicket?.last_step?.insert_date">
          <small class="text-muted mb-0 pb-0">{{ "LAST_UPDATE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentTicket?.last_step?.insert_date) }}</p>
        </div>
        <div class="col-6" *ngIf="currentTicket?.enabled_label">
          <small class="text-muted mb-025 pb-0 d-block">{{ "STATUS_LABEL" | translate }}:</small>
          <span class="badge mb-1" [ngClass]="{
          'badge-secondary': currentTicket?.last_step?.status===0,
          'badge-warning': currentTicket?.last_step?.status===1,
          'badge-success': currentTicket?.last_step?.status===2
          }">{{ currentTicket?.enabled_label | translate }}</span>
        </div>
        <div class="col-6" *ngIf="currentTicket?.last_step?.operator?.complete_name && currentTicket?.last_step?.status === 1">
          <small class="text-muted mb-0 pb-0">{{ "OPERATOR" | translate }}:</small>
          <p>{{ currentTicket?.last_step?.operator?.complete_name }}</p>
        </div>
        <div class="col-12" *ngIf="currentTicket?.note">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <div [innerHTML]="currentTicket?.note"></div>
        </div>
        <div class="col-12" *ngIf="currentTicket?.open_attachments && currentTicket?.open_attachments.length > 0">
          <small class="text-muted mb-0 pb-0">{{ "ATTACHMENTS" | translate }}:</small>
          <div class="row align-items-center" *ngFor="let file of currentTicket?.open_attachments">
            <div class="col-12">
              <button type="button" (click)="_utilService.getFile(file.file_url)" class="btn border-0 mr-2 px-0 text-primary" [ngbTooltip]="'VIEW' | translate">
                <span [data-feather]="'eye'" size="16"></span>
              </button>
              <span>{{ file.filename }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentTicket?.last_step.status === 2" class="row">
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12">
          <h3>{{ "STAFF_RESPONSE" | translate }}</h3>
        </div>
        <div class="col-6" *ngIf="currentTicket?.last_step?.operator?.complete_name">
          <small class="text-muted mb-0 pb-0">{{ "OPERATOR" | translate }}:</small>
          <p>{{ currentTicket?.last_step?.operator?.complete_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "DATE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentTicket?.last_step?.insert_date) }}</p>
        </div>
        <div class="col-12" *ngIf="currentTicket?.close_attachments && currentTicket?.close_attachments.length > 0">
          <small class="text-muted mb-0 pb-0">{{ "ATTACHMENTS" | translate }}:</small>
          <div class="row align-items-center" *ngFor="let file of currentTicket?.close_attachments">
            <div class="col-12">
              <button type="button" (click)="_utilService.getFile(file.file_url)" class="btn border-0 mr-2 px-0 text-primary" [ngbTooltip]="'VIEW' | translate">
                <span [data-feather]="'eye'" size="16"></span>
              </button>
              <span>{{ file.filename }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <small class="text-muted mb-0 pb-0">{{ "RESPONSE" | translate }}:</small>
          <div [innerHTML]="currentTicket?.last_step?.response"></div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="modal.close()" type="button" class="btn btn-outline-primary">{{ "BACK" | translate }}</button>
      <button class="btn btn-primary" has_capability="ticket_manage_status" *ngIf="currentTicket?.last_step?.status === null || currentTicket?.last_step?.status === 0" (click)="modal.close(); takeCharge(currentTicket)">
        {{ "TAKE_CHARGE" | translate }}
      </button>
      <button class="btn btn-primary" has_capability="ticket_manage_status" *ngIf="currentTicket?.last_step?.status === 1 && currentTicket?.last_step?.operator?.hash === me.hash" (click)="modalOpen(replyTicket, currentTicket)">
        {{ "CLOSE_SUPPORT_REQUEST" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Detail Ticket -->

<!-- Modal Reply Ticket -->
<ng-template #replyTicket let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ERRORS.INSERT_MESSAGE" | translate }}</h3>
      <div class="form-group" *ngIf="currentTicket?.note && currentTicket?.note.length > 0">
        <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
        <div class="ticket-notes" [innerHTML]="currentTicket?.note"></div>
      </div>
      <div class="form-group">
        <label for="messageReplyTicket">{{ "RESPONSE" | translate }}<sup class="text-danger">*</sup></label>
        <textarea name="messageReplyTicket" id="messageReplyTicket" class="form-control" [(ngModel)]="messageReplyTicket"></textarea>
      </div>
      <div class="form-group">
        <label for="invoice_attachments">{{ "ATTACHMENTS" | translate }}</label>
        <div id="invoice_attachments" class="custom-file">
          <input class="custom-file-input" type="file" lang="it" id="custom-file-input" [multiple]="true" accept="image/*, application/pdf, .doc, .docx" (change)="addAttachmentToList($any($event).target.files)" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>
      <div class="form-group pt-1" *ngIf="attachmentsListObj.length > 0">
        <div *ngFor="let attachment of attachmentsListObj; let i_attachment = index" class="d-flex border-bottom mb-1 pb-1">
          <div class="flex-basis-60 d-flex align-items-center">
            <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i_attachment)" *ngIf="attachment.status === 0">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
            <div class="mt-025">{{ attachment.name }}</div>
          </div>
          <div class="flex-basis-20 text-right">{{ attachment.size }}</div>
        </div>
        <div>{{ "TOTAL" | translate }}: {{ attachmentsListObj.length }}</div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()">{{ "CANCEL" | translate }}</button>
      <button has_capability="ticket_manage_status" [disabled]="messageReplyTicket.length < 1" (click)="modal.close(); sendReplyTicket()" type="submit" class="btn btn-primary w-150">{{ "SEND" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal Reply Ticket -->